import {
    CHANGE_ORDER_SHIPMENTS_PAGE,
    GET_ALL_ORDER_SHIPMENTS,
    GET_ONE_ORDER_SHIPMENT,
    SEARCH_ORDER_SHIPMENTS,
} from '../types'

const initialState = {
    orderShipments: null,
    orderShipment: null,
    pages: '',
    page: '',
    count: '',
    keyword: '',
}

const orderShipmentReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case GET_ALL_ORDER_SHIPMENTS:
            return {
                ...state,
                orderShipments: payload.orderShipments,
                pages: payload.pages,
                page: payload.page,
                count: payload.count,
                keyword: payload.keyword,
                orderShipment: null,
            }
        case SEARCH_ORDER_SHIPMENTS:
            return {
                ...state,
                keyword: payload.keyword,
                page: 1,
            }
        case CHANGE_ORDER_SHIPMENTS_PAGE:
            return {
                ...state,
                page: payload,
            }
        case GET_ONE_ORDER_SHIPMENT:
            return {
                ...state,
                orderShipment: payload,
            }
        default:
            return state
    }
}

export default orderShipmentReducer
